<h1 class="registration-title text-center font-50 my-4 text-capitalize">
  {{ 'account.forgotdata.password_retrieval.heading' | translate }}
</h1>
<!-- <div class="registration-form-block mb-1">
  <ng-container *ngIf="success$ | async; else forgotPasswordForm">
    <p>{{ 'account.send_password.message' | translate }}</p>
  </ng-container>

  <ng-template #forgotPasswordForm>
    <p [ishServerHtml]="'account.forgotdata.password_retrieval_info.text' | translate"></p>

    <ish-error-message [error]="error$ | async"></ish-error-message>

    <div class="row">
      <div class="col-xl-12">
        <ish-request-reminder-form
          (submitPasswordReminder)="requestPasswordReminder($event)"
        ></ish-request-reminder-form>
      </div>
    </div>
  </ng-template>
</div> -->
<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-lg-6 border p-4">
      <ng-container *ngIf="success$ | async; else forgotPasswordForm">
        <p>{{ 'account.send_password.message' | translate }}</p>
      </ng-container>

      <ng-template #forgotPasswordForm>
        <p [ishServerHtml]="'account.forgotdata.password_retrieval_info.text' | translate"></p>

        <ish-error-message [error]="error$ | async"></ish-error-message>

        <div class="row">
          <div class="col-xl-12">
            <ish-request-reminder-form
              (submitPasswordReminder)="requestPasswordReminder($event)"
            ></ish-request-reminder-form>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<ish-loading *ngIf="loading$ | async"></ish-loading>
